@defer (when products?.length > 0) {
  @if (products?.length > 0) {
    <sd-product-comparator-sticky
      [ngClass]="{ 'is-sticky': isSticky }"
      [comparedProducts]="products"
      [maxProducts]="maxProducts"
      (deleteProduct)="removeProduct($event)"
      (compareProducts)="goToComparator()"
    />
  }
}

@defer (when isWrongCategoryModalOpened) {
  <sd-modal-default
    [(isOpened)]="isWrongCategoryModalOpened"
    [modalTitle]="'comparator.modal.wrongCategoryTitle' | translate"
    [modalTitleLevel]="4"
  >
    <p sd-modal-body>
      {{ 'comparator.modal.wrongCategoryDescription' | translate }}
    </p>
    <footer class="c__modal-actions" sd-modal-footer>
      <button sd-button (click)="addDifferentCategory()">
        <span>{{ 'comparator.modal.wrongCategoryContinueButton' | translate }}</span>
      </button>
      <button sd-button (click)="isWrongCategoryModalOpened = false" [isSecondary]="true">
        <span>{{ 'comparator.modal.wrongCategoryCancelButton' | translate }}</span>
      </button>
    </footer>
  </sd-modal-default>
}
